module.exports = __webpack_public_path__ + "assets/img/cancel.e975f0ee.png";